import React, { useState, useEffect } from "react";
import axios from "axios";
import { useUser } from './Context/UserContext';
import { Table, Container, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from "reactstrap";
import "../styles/VerifierApprovalForm.css";
import { Link } from "react-router-dom";
import profileImg from "../assets/logo.png";
import VendorInfoTabs from "./VendorInfoTabs";
import DashboardLayout from "./DashboardLayout";


const VerifierApprovalForm  = () => {
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [vendors, setVendors] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const { user } = useUser();
    const [showCard, setShowCard] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [activeTab, setActiveTab] = useState("details");
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [comment, setComment] = useState("");
    const [commentError, setCommentError] = useState("");
    const [sortBy, setSortBy] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [subTab, setSubTab] = useState("details");
    const [approvalStatusError, setApprovalStatusError] = useState("");
    const [rejectionSendToError, setRejectionSendToError] = useState("");
    const [isSaved, setIsSaved] = useState(false);
    const [departmentHeadError, setDepartmentHeadError] = useState("");
    const [departmentTypeError, setDepartmentTypeError] = useState("");
    const [status, setStatus] = useState("");
    const [comments, setComments] = useState("");
    const [deptId, setDeptId] = useState("");
    const [headId, setHeadId] = useState("");
    const [departments, setDepartments] = useState([]);
    const [departmentHeads, setDepartmentHeads] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [approverId, setApproverId] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
   /* const [selectedStatus, setSelectedStatus] = useState(3);*/ // Pending by default
    const [selectedStatus, setSelectedStatus] = useState(3);
    const [users, setUsers] = useState([]);
    const [approvalDetails, setApprovalDetails] = useState(null);
    const [showSaveBtn, setShowSaveBtn] = useState(true);
    const { user: loggedInUser } = useUser(); // rename to avoid conflicts with 'user' state
    const [backendStatus, setBackendStatus] = useState(null);
    const isReadOnly = backendStatus === "1" || backendStatus === "2";
    const [isRejectMode, setIsRejectMode] = useState(false);

    useEffect(() => {
        const id = loggedInUser?.empId || sessionStorage.getItem("userId");
        if (id) {
            setApproverId(id); // ensure number
            console.log("✅ Approver ID set:", id);
        } else {
            console.log("⏳ Waiting for user info to load...");
        }
    }, [loggedInUser]);

    useEffect(() => {
        const dark = localStorage.getItem("darkMode") === "true";
        document.body.classList.toggle("dark-mode", dark);
    }, []);

    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const res = await axios.get("/department/departments"); //  Corrected URL
                console.log("Departments fetched:", res.data);
                setDepartments(res.data);
            } catch (err) {
                console.error("Failed to load departments", err);
            }
        };
        fetchDepartments();
    }, []);


    useEffect(() => {
        if (!selectedVendor?.departmentType) {
            setDepartmentHeads([]);
            return;
        }

        axios
            .get(`/department/department-heads/${selectedVendor.departmentType}`)
            .then((res) => {
                setDepartmentHeads(res.data);
                setSelectedVendor((prev) => {
                    const valid = res.data.some(
                        (head) => String(head.empId) === String(prev.departmentHead)
                    );
                    return valid ? prev : { ...prev, departmentHead: "" };
                });
            })
            .catch((err) => console.error("Failed to load department heads", err));
    }, [selectedVendor?.departmentType]);


    useEffect(() => {
        console.log("Selected Vendor:", selectedVendor);

        if (selectedVendor && selectedVendor.userId) {
            axios
                .get(`/api/approvalstatus/verifier-history/${selectedVendor.userId}`)
                .then(response => {
                    console.log("Approval History Data:", response.data);
                    setUsers(Array.isArray(response.data) ? response.data : []);
                })
                .catch(error => {
                    if (error.response?.status === 404) {
                        // No approval history yet — not a real error
                        setUsers([]);
                    } else {
                        console.error("Error fetching approval status:", error);
                        setUsers([]); // fail safe, never let users become non-array
                    }
                });
        }
    }, [selectedVendor]);

    const usersPerPage = 6; // Only 6 users per page
    const vendorsPerPage = 6;

    const filteredVendors = vendors.filter(vendor =>
        vendor.nameOfCompany?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const startIndex = (currentPage - 1) * vendorsPerPage;
    const endIndex = startIndex + vendorsPerPage;
    const totalPages = Math.ceil(vendors.length / vendorsPerPage);
    const vendorsForPage = filteredVendors.slice(startIndex, endIndex);

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "Invalid Date";
        return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
    };
    const handlePageChange = (type) => {
        if (type === "first") setCurrentPage(1);
        if (type === "prev" && currentPage > 1) setCurrentPage(currentPage - 1);
        if (type === "next" && currentPage < totalPages) setCurrentPage(currentPage + 1);
        if (type === "last") setCurrentPage(totalPages);
    };
    console.log("Clicked user:", user);
    const handleReviewClick = (index) => {

        const vendor = vendors[index]; 
        console.log("Clicked vendor:", vendor); 
        console.log("Clicked vendor full object:", vendor); 
        setSelectedVendor({
            ...vendor,
            userId: vendor.userId || vendor.UserId || vendor.userid || vendor.id || null, 
            index
        });

        setShowModal(true);
        setIsEditing(false);
        setActiveTab("history");
    };

    const statusMapping = {
        Pending: 3,   // pStatusID = 1 → returns status 4
        Rejected: 2,  // pStatusID = 2 → returns 17,18
        Approved: 1   // pStatusID = 3 → returns 19
    };

    const mapBackendStatusToUI = (status) => {
        if (status === 19) return "1";  // Approved
        if (status === 17 || status === 18) return "2";  // Rejected
        return "3"; // Default
    };

    const mapVerifierSendTo = (status) => {
        if (status === 17) return "PO";
        if (status === 18) return "Vendor";
        return "";
    };


    useEffect(() => {
        loadVendors(selectedStatus);
    }, [selectedStatus]);

    const loadVendors = async (status) => {
        try {
            if (!user?.empId) {
                console.error("User not loaded yet");
                return;
            }

            const res = await axios.get(
                "/api/vendordetails/verifier-vendors",
                {
                    params: {
                        statusId: status,
                        empId: user.empId  
                    }
                }
            );

            setVendors(res.data);
        } catch (error) {
            console.error("Error loading verifier vendors:", error);
        }
    };

    const handleInputChange = (e, field) => {
        setSelectedVendor({ ...selectedVendor, [field]: e.target.value });
    };


    useEffect(() => {
        if (!selectedVendor?.id || !approverId || !showModal) return;

        axios.get("/api/approvalstatus/vendor-latest-approval", {
            params: { vendorId: selectedVendor.id, approvalId: approverId }
        })
            .then(res => {
                const data = res.data;
                const uiStatus = mapBackendStatusToUI(data.approvalStatus);

                setBackendStatus(uiStatus);

                // show fields only when Approved (1) or Rejected (2)
                setSelectedVendor(prev => ({
                    ...prev,
                    ...(uiStatus === "1" || uiStatus === "2" ? {
                        departmentType: data.dept_ID,
                        departmentHead: data.dept_headID,
                        deptHeadName: data.deptHeadName,
                        deptTypeName: data.departmentName,
                        approvalStatus: uiStatus,
                        comment: data.approvalComments,
                        rejectionSendTo:
                            uiStatus === "2"
                                ? mapVerifierSendTo(data.approvalStatus)
                                : ""
                    } : {})
                }));

                setShowSaveBtn(uiStatus !== "1" && uiStatus !== "2");
            })
            .catch(err => console.error(err));
    }, [selectedVendor?.id, approverId, showModal]);


    const handleVerifierSubmit = async () => {
        if (isReadOnly) {
            console.warn("⚠ Read-only mode: submission disabled");
            return; // ⛔ Prevent validation + API call
        }
        console.log("Current Approver ID:", approverId);

        if (!approverId || approverId.trim() === "") {
            alert("Approver ID missing or invalid. Please wait until user info loads.");
            return;
        }

        let isValid = true;
        setApprovalStatusError("");
        setCommentError("");
        setRejectionSendToError("");

        // ----------------------------
        // VALIDATION
        // ----------------------------
        if (String(selectedVendor?.approvalStatus) !== "1" &&
            String(selectedVendor?.approvalStatus) !== "2") {
            setApprovalStatusError("Approval status is required");
            isValid = false;
        }

        if (!selectedVendor?.comment?.trim()) {
            setCommentError("Comment is required");
            isValid = false;
        }

        if (String(selectedVendor?.approvalStatus) === "2" && !selectedVendor?.rejectionSendTo) {
            setRejectionSendToError("Rejection target is required");
            isValid = false;
        }

        if (!selectedVendor?.id) {
            console.error("Vendor ID missing");
            isValid = false;
        }

        if (!isValid) return;

        // ----------------------------
        // FINAL PAYLOAD
        // ----------------------------
        const payload = {
            VendorId: Number(selectedVendor.id),
            ApproverId: approverId, // numeric
            ApproveStatus: Number(selectedVendor.approvalStatus),
            Comments: selectedVendor.comment.trim(),
            SendTo:
                Number(selectedVendor.approvalStatus) === 2
                    ? selectedVendor.rejectionSendTo
                    : null
        };

        console.log("Sending Payload:", payload);

        // ----------------------------
        // API CALL
        // ----------------------------
        try {
            const response = await axios.post(
                "/api/ApprovalStatus/verifier-approval",
                payload
            );

            alert(response.data.message);
                setVendors(prev => prev.filter(v => v.id !== selectedVendor.id));
                setShowModal(false);
        } catch (error) {
            console.error("Submit Error:", error);

            if (error.response?.data?.errors) {
                const msgs = Object.entries(error.response.data.errors)
                    .map(([f, errs]) => `${f}: ${errs.join(", ")}`)
                    .join("\n");
                alert("Validation Errors:\n" + msgs);
            } else {
                alert(error.response?.data?.error || "Something went wrong.");
            }
        }
    };

    const handleSort = (column) => {
        const sortedVendors = [...vendors].sort((a, b) => {
            let valueA, valueB;

            if (column === "approvalStatus") {
                valueA = a.approvalStatus?.toLowerCase() || "";
                valueB = b.approvalStatus?.toLowerCase() || "";
            }

            if (sortOrder === "asc") {
                return valueA > valueB ? 1 : -1;
            } else {
                return valueA < valueB ? 1 : -1;
            }
        });

        setVendors(sortedVendors);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        setSortBy(column);
    };

    const handleReject = () => {
        if (selectedVendor && selectedVendor.index !== undefined) {
            const updatedVendors = [...vendors];
            updatedVendors[selectedVendor.index].approvalStatus = "Rejected";
            setVendors(updatedVendors);
        }
        setShowModal(false);
    };

    return (
        <DashboardLayout>
            {/*<div>*/}
            {/*    Approver ID: {approverId ? approverId : "Loading..."}*/}
            {/*</div>*/}
        <div className="vendor-registration-details">

                    <Container>
                    <h2 className="page-title" style={{ marginTop: 0, marginBottom: '15px', color: '#0a4275', paddingTop: '10px' }}>
                        Vendors Details
                    </h2>
                    <div
                        style={{
                            width: "100%",                
                            display: "flex",
                            justifyContent: "space-between", 
                            alignItems: "center",
                            marginBottom: "15px",
                        }}
                    >
                         {/*🔹 Search Box — Left Side */}
                        <div style={{ flex: 1, textAlign: "left" }}>
                            <Input
                                type="text"
                                placeholder="Search by Company Name..."
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setCurrentPage(1); // reset to first page when searching
                                }}
                                style={{
                                    width: "250px",
                                    borderRadius: "4px",
                                    fontSize: "14px",
                                }}
                            />
                        </div>

                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                flex: 1,
                                justifyContent: "flex-end",
                            }}
                           >
                            <label style={{ fontWeight: "500", color: "#0a4275" }}>
                                Approved Status:
                            </label>

                            <Input
                                type="select"
                                value={selectedStatus}
                                onChange={(e) => {
                                    const value = Number(e.target.value);
                                    setSelectedStatus(value);
                                    setIsRejectMode(value === 3); 
                                }}
                                style={{
                                    width: "250px",
                                    borderRadius: "8px",
                                    height: "35px",
                                    paddingLeft: "3px",
                                    fontSize: "14px",
                                }}
                            >
                                {Object.entries(statusMapping).map(([label, value]) => (
                                    <option key={value} value={value}>
                                        {label}
                                    </option>
                                ))}
                            </Input>
                        </div>
                    </div>
                   
                    {searchTerm && vendorsForPage.length === 0 && (
                        <div
                            style={{
                                color: "red",
                                fontWeight: "500",
                                marginBottom: "10px",
                                textAlign: "left", // under search box
                            }}
                        >
                            Company Name not found
                        </div>
                    )}
                        <Table bordered className="vendor-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Company Name</th>
                                    <th>Contact Person</th>
                                    <th>Nature of Supply</th>
                                    <th>MSME</th>
                                    <th>PAN Number</th>
                                    <th>GST Number</th>
                                    <th>HSN/SAC Code</th>
                                    <th onClick={() => handleSort("approvalStatus")} style={{ cursor: "pointer" }}>
                                        Approval Status {sortBy === "approvalStatus"
                                            ? (sortOrder === "asc" ? "▲" : "▼")
                                            : "⇅"}
                                    </th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                        <tbody>
                            {vendorsForPage.length === 0 ? (
                                <tr><td colSpan="10">No pending vendors found.</td></tr>
                            ) : (
                                vendorsForPage.map((vendor, index) => (
                                    <tr key={vendor.vendorCode || index}>
                                        <td>{startIndex + index + 1}</td>
                                        <td>{vendor.nameOfCompany}</td>
                                        <td>{vendor.contactPersonName || "N/A"}</td>
                                        <td>{vendor.natureOfSupply}</td>
                                        <td>{vendor.msmeNo || "N/A"}</td>
                                        <td>{vendor.pan || "N/A"}</td>
                                        <td>{vendor.gst || "N/A"}</td>
                                        <td>{vendor.hsNsacCode || "N/A"}</td>
                                        <td>{vendor.approvalStatus || "N/A"}</td>
                                        <td>
                                            <button className="review-btn" onClick={() => handleReviewClick(startIndex + index)}>
                                                Review
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>

                        </Table>

                        <div className="pagination">
                            <button onClick={() => handlePageChange("first")} disabled={currentPage === 1}>First</button>
                            <button onClick={() => handlePageChange("prev")} disabled={currentPage === 1}>Previous</button>
                            <span className="page-info">Page {currentPage} of {totalPages}</span>
                            <button onClick={() => handlePageChange("next")} disabled={currentPage === totalPages}>Next</button>
                            <button onClick={() => handlePageChange("last")} disabled={currentPage === totalPages}>Last</button>
                        </div>
                    </Container>

                    <Modal isOpen={showModal} toggle={() => setShowModal(false)} centered className="modal-lg custom-modal">
                        <ModalHeader toggle={() => setShowModal(false)}>Vendor Details</ModalHeader>
                        <div className="tabs1">
                            <span className={activeTab === "history" ? "active-tab" : ""} onClick={() => setActiveTab("history")}>Vendor Approval History</span>
                            <span className={activeTab === "info" ? "active-tab" : ""} onClick={() => setActiveTab("info")}>Info</span>
                            <span className={activeTab === "details" ? "active-tab" : ""} onClick={() => setActiveTab("details")}>Approve/Reject</span>
                        </div>
                        <ModalBody>

                            {activeTab === "history" && selectedVendor && (
                                <div className="history-container">
                                    <Table bordered className="history-table">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Approval Status</th>
                                                <th>Approver Name</th>
                                                <th>Date</th>
                                                <th>Comments</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {users.length > 0 ? (
                                                users.map((user, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{user.approvalStatus || "N/A"}</td>
                                                        <td>{user.approvalName || "N/A"}</td>
                                                        <td>
                                                            {user.createDate
                                                                ? (() => {
                                                                    const date = new Date(user.createDate);

                                                                    const day = String(date.getDate()).padStart(2, "0");
                                                                    const month = String(date.getMonth() + 1).padStart(2, "0");
                                                                    const year = date.getFullYear();

                                                                    const hours = String(date.getHours()).padStart(2, "0");
                                                                    const minutes = String(date.getMinutes()).padStart(2, "0");
                                                                    const seconds = String(date.getSeconds()).padStart(2, "0");

                                                                    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
                                                                })()
                                                                : "N/A"}
                                                        </td>

                                                        <td>{user.comments || "N/A"}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center">No history found</td>
                                                </tr>
                                            )}

                                        </tbody>
                                    </Table>
                                </div>
                            )}
                            {activeTab === "info" && selectedVendor && (
                                <VendorInfoTabs
                                    selectedVendor={selectedVendor}
                                    isEditing={isEditing}
                                    setIsEditing={setIsEditing}
                                    handleInputChange={handleInputChange}
                                    subTab={subTab}
                                    setSubTab={setSubTab}
                                    type="vendor"
                                />
                            )}
                        {activeTab === "details" && selectedVendor && (
                            <div className="details-container">
                                <>
                                    <Table bordered className="info-table1">
                                        <tbody>
                                            <tr>
                                                <th>Name of Company:</th>
                                                <td>{selectedVendor?.nameOfCompany || "N/A"}</td>

                                            </tr>
                                           
                                            <tr>
                                                <th>Approval Status:<span className="required-field">*</span></th>
                                                <td>
                                                    <Input
                                                        type="select"
                                                        disabled={isReadOnly}
                                                        className="full-width-dropdown"
                                                        value={selectedVendor?.approvalStatus || ""}
                                                        
                                                        onChange={(e) => {
                                                            const value = e.target.value;

                                                            setSelectedVendor({
                                                                ...selectedVendor,
                                                                approvalStatus: value,
                                                                // 🔥 Clear rejectionSendTo when not rejected
                                                                rejectionSendTo: value === "2" ? selectedVendor.rejectionSendTo : ""
                                                            });

                                                            setApprovalStatusError("");
                                                        }}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="1">Approved</option>
                                                        <option value="2">Rejected</option>
                                                    </Input>

                                                    {approvalStatusError && (
                                                        <div className="text-danger" style={{ marginTop: "4px" }}>
                                                            {approvalStatusError}
                                                        </div>
                                                    )}

                                                </td>
                                                <th>Comments:<span className="required-field">*</span></th>
                                                <td>
                                                    <Input
                                                        type="textarea"
                                                        disabled={isReadOnly}
                                                        value={selectedVendor?.comment || ""}
                                                        onChange={(e) => {
                                                            setSelectedVendor({ ...selectedVendor, comment: e.target.value });
                                                            setCommentError("");   // 👈 Clear comment error also
                                                        }}
                                                        placeholder="Enter your comment..."
                                                    />

                                                    {commentError && (
                                                        <div className="text-danger">{commentError}</div>
                                                    )}
                                                </td>
                                            </tr>
                                            
                                            <tr>
                                                <th>Rejection Send To:<span className="required-field">*</span></th>
                                                <td>
                                                    <Input
                                                        type="select"
                                                        disabled={isReadOnly || selectedVendor?.approvalStatus !== "2"}
                                                        className="full-width-dropdown"
                                                        value={selectedVendor?.rejectionSendTo || ""}
                                                        onChange={(e) => {
                                                            setSelectedVendor({
                                                                ...selectedVendor,
                                                                rejectionSendTo: e.target.value
                                                            });
                                                            setRejectionSendToError("");
                                                        }}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="Vendor">Vendor</option>
                                                        <option value="PO">PO</option>
                                                    </Input>

                                                    {rejectionSendToError && (
                                                        <div className="text-danger">{rejectionSendToError}</div>
                                                    )}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                    <ModalFooter>
                                        
                                        {showSaveBtn && (
                                            <Button color="success" onClick={handleVerifierSubmit}>Save</Button>
                                        )}

                                        <Button color="danger" onClick={() => setShowModal(false)}>Close</Button>
                                    </ModalFooter>
                                </>
                            </div>
                        )}
                        </ModalBody>
                    </Modal>
            </div>
        </DashboardLayout>
    );
};
export default VerifierApprovalForm ;